"use client";
import Link from "next/link";
import React, { useEffect, useRef, useState } from "react";
import { ReactSVG } from "react-svg";
import { Menu, MenuItem, ListItemText, List } from "@mui/material";
import "./ServicesNav.scss";
import Image from "next/image";
import { motion } from "framer-motion";
import { useRouter } from "next/navigation";
import { useAtomValue } from "jotai";
import { categoriesAtom } from "@webelocity/state";
import SingleProductAPI from "../ShopPages/SingleProductAPI/SingleProductAPI";
import FallBackImage from "../FallBackImage/FallBackImage";
import { useQuery } from "@tanstack/react-query";
import { ApiResponse, Product } from "@webelocity/core";;
import { shopApi } from "@/lib/shopApi";
import { Button } from "@webelocity/ui";
import { PiListBold } from "react-icons/pi";

import MegaMenu from "../Shared/MegaMenu/MegaMenu";
import QuoteRequestPopup from "../Shared/QuoteRequest/QuoteRequestPopup";
// import PaymentsButton from "../PaymentsButton/PaymentsButton";
interface ServicesNavProps {
  monthlyFlyerUrl: string;
}

const ServicesNav: React.FC<ServicesNavProps> = ({ monthlyFlyerUrl }) => {
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState<boolean>(false);
  const [serviceAnchorEl, setServiceAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const [contractorAnchorEl, setContractorAnchorEl] =
    useState<null | HTMLElement>(null);
  const isServiceMenuOpen = Boolean(serviceAnchorEl);
  const isContractorsMenuOpen = Boolean(contractorAnchorEl);
  const router = useRouter();
  const NavBarRef = useRef<HTMLDivElement>(null);
  const megaMenuRef = useRef<HTMLDivElement>(null);
  const serviceMenuRef = useRef<HTMLDivElement>(null);
  const contractorsMenuRef = useRef<HTMLDivElement>(null);
  const categories = useAtomValue(categoriesAtom);
  const catStatus = categories.length > 0 ? 'succeeded' : 'loading';


  const shopButtonRef = useRef<HTMLDivElement>(null);

  const onCloseMegaMenu = () => {
    setIsMegaMenuOpen(false);
  }

  const handleShopClick = () => {
    setIsMegaMenuOpen(!isMegaMenuOpen);
  }


  return (
    <div
      ref={NavBarRef}
      className={`services-nav-wrapper baseContainer`}>
      <div className='section-wrap maxWidth'>
        <div className='left-section'>
          <div className="flex items-center" ref={shopButtonRef}>
            <Button
              variant={isMegaMenuOpen ? "secondary" : "outline"}
              onClick={handleShopClick}
            >
              <List className="text-2xl cursor-pointer " /> <PiListBold className="text-2xl cursor-pointer " />
              Shop
            </Button>
          </div>
        </div>

        <div className='middle'>
          <div className='link-wrapper'>
            <Link
              className='text-mini-14 nav-link black weight-600'
              href={"/about"}
              aria-label='About Us'>
              About Us
            </Link>
          </div>

          <div
            className='link-wrapper'
            ref={serviceMenuRef}
            onClick={(e) => {
              setServiceAnchorEl(e.currentTarget);
            }}
            aria-controls={isServiceMenuOpen ? "services-menu" : undefined}
            aria-haspopup='true'
            aria-expanded={isServiceMenuOpen ? "true" : undefined}>
            <p className='text-mini-14 nav-link black weight-600'>
              Services
            </p>
            <motion.div
              className='arrow-wrapper'
              animate={{ rotate: isServiceMenuOpen ? 180 : 0 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}>
              <ReactSVG
                src='/assets/ServicesNav/arrow-down-ic.svg'
                aria-hidden
              />
            </motion.div>
          </div>
          <Menu
            id='services-menu'
            anchorEl={serviceAnchorEl}
            open={isServiceMenuOpen}
            onClose={() => setServiceAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{ sx: { minWidth: 180, borderRadius: 2, mt: 1 } }}>
            <MenuItem
              component={Link}
              href='/services'
              onClick={() => setServiceAnchorEl(null)}
              sx={{ color: '#000' }}>
              <ListItemText>Our Services</ListItemText>
            </MenuItem>
            <MenuItem
              component={Link}
              href='/flexiti-financing'
              onClick={() => setServiceAnchorEl(null)}
              sx={{ color: '#000' }}>
              <ListItemText>Flexiti Financing</ListItemText>
            </MenuItem>
          </Menu>

          <div
            className='link-wrapper'
            onClick={(e) => {
              setContractorAnchorEl(e.currentTarget);
            }}
            aria-controls={
              isContractorsMenuOpen ? "contractors-menu" : undefined
            }
            aria-haspopup='true'
            aria-expanded={isContractorsMenuOpen ? "true" : undefined}>
            <p className='text-mini-14 nav-link black weight-600'>
              Contractors
            </p>
            <motion.div
              className='arrow-wrapper'
              animate={{ rotate: isContractorsMenuOpen ? 180 : 0 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}>
              <ReactSVG
                src='/assets/ServicesNav/arrow-down-ic.svg'
                aria-hidden
              />
            </motion.div>
          </div>
          <Menu
            id='contractors-menu'
            anchorEl={contractorAnchorEl}
            open={isContractorsMenuOpen}
            onClose={() => setContractorAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{ sx: { minWidth: 220, borderRadius: 2, mt: 1 } }}>
            <MenuItem
              component={Link}
              href='/account-applications'
              onClick={() => setContractorAnchorEl(null)}
              sx={{ color: '#000' }}>
              <ListItemText>Account Application</ListItemText>
            </MenuItem>
            <MenuItem
              component={Link}
              href='/magazine-subscription'
              onClick={() => setContractorAnchorEl(null)}
              sx={{ color: '#000' }}>
              <ListItemText>Magazine Subscription</ListItemText>
            </MenuItem>
            <MenuItem
              component={Link}
              href='/Referral'
              onClick={() => setContractorAnchorEl(null)}
              sx={{ color: '#000' }}>
              <ListItemText>Referral Form</ListItemText>
            </MenuItem>
          </Menu>

          <div className='link-wrapper'>
            <Link
              className='text-mini-14 nav-link black weight-600'
              href={"/chickens"}
              aria-label='Chick Orders'>
              Chick Orders
            </Link>
          </div>

          {monthlyFlyerUrl && (
            <div className='link-wrapper'>
              <Link
                className='text-mini-14 nav-link black weight-600'
                href={monthlyFlyerUrl}
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Monthly Flyer (opens in a new tab)'>
                Monthly Flyer
              </Link>
            </div>
          )}

          <div className='link-wrapper'>
            <Link
              className='text-mini-14 nav-link black weight-600'
              href={"/careers"}
              aria-label='Careers'>
              Careers
            </Link>
          </div>

          <div className='link-wrapper'>
            <Link
              className='text-mini-14 nav-link black weight-600'
              href={"/building-packages"}
              aria-label='Building Packages'>
              Building Packages
            </Link>
          </div>

          <div className='link-wrapper'>
            <Link
              className='text-mini-14 nav-link black weight-600'
              href={"/contact"}
              aria-label='Contact Us'>
              Contact Us
            </Link>
          </div>
        </div>

        <div className='right'>
          {/* <PaymentsButton /> */}
          <QuoteRequestPopup
            triggerLabel="Request a Quote"
            triggerVariant="button"
            triggerClassName="nav-btn btn"
            buttonVariant="primary"
          />
        </div>
      </div>
      <MegaMenu isOpen={isMegaMenuOpen} onClose={onCloseMegaMenu} shopButtonRef={shopButtonRef} />

    </div>
  );
};

export default ServicesNav;
